// extracted by mini-css-extract-plugin
module.exports = {"benefit":"BecomeMember_benefit__MGpwR"};